import React, { FunctionComponent, useContext, useState } from 'react'
import styles from './TagEditor.module.sass'
import clsx from 'clsx'
import Field from '../../../controls/Field/Field'
import { Tag } from '../../../../responses/tags'
import TagList from '../TagList/TagList'
import TagIcon from 'files/tag/tag.svg'
import { inactiveContext } from '../../../../constants/contexts'

interface Props {
    className?: string,
    tags: Tag[],
    constantTags: Tag[],
    onAdd?: (tag: string) => void,
    onDelete?: (tag: Tag) => void,
    inverted?: boolean,
    editable?: boolean,
}

const TagEditor: FunctionComponent<Props> = props => {
    const [text, setText] = useState('')

    const inactive = useContext(inactiveContext)
    const editable = props.editable && !inactive

    const addTag = () => {
        if (text) {
            props.onAdd?.(text)
            setText('')
        }
    }

    return <div className={clsx(props.className, styles.tags)}>
        <TagIcon className={styles.icon}/>
        <TagList
            className={styles.list}
            delete={editable}
            inverted={props.inverted}
            tags={props.tags}
            constantTags={props.constantTags}
            disabled={!editable}
            onClick={props.onDelete}
        >
            {
                editable && <Field
                    className={styles.field}
                    value={text}
                    onChange={setText}
                    placeholder={'Добавить теги'}
                    onEnter={addTag}
                />
            }
        </TagList>
    </div>
}

export default TagEditor